import {post, get} from '@/lib/axios';

const faq = {
  async get_faq_questions() {
    return get(`/faq`);
  },
  async post_faq_questions(data) {
    return post(`/faq`, data);
  },
};

export {faq as default};

